

const VideoPlayer = ({ videoId, player }) => {

    const { height, controls, rel, modestBranding, annotation, fs } = player;
    return <div className='iframeEle'>
        <iframe id="" height={height} src={`https://www.youtube.com/embed/${videoId}?autoplay=0&controls=${controls ? 1 : 0}&mute=0&rel=${rel ? 0 : 1}&modestbranding=${modestBranding ? 0 : 1}&iv_load_policy=${annotation ? 1 : 3}&fs=${fs ? 0 : 1}&enablejsapi=1`} frameBorder="0"></iframe>
    </div>
}
export default VideoPlayer;